import { ComponentRef, Directive, Input, OnChanges, SimpleChanges, ViewContainerRef } from '@angular/core';

import { SpinnerLoaderComponent } from '../components/spinner-loader/spinner-loader.component';

@Directive({
  selector: '[spinnerLoader]'
})
export class SpinnerLoaderDirective implements OnChanges {
  @Input() spinnerLoader!: boolean;
  @Input() size?: string;

  private spinnerRef!: ComponentRef<any>;
  
  constructor(public viewContainerRef: ViewContainerRef) { }
  
  ngOnChanges(changes: SimpleChanges): void {
    for (const key in changes) {
      if (changes.hasOwnProperty(key)) {
        if (key === 'spinnerLoader' && typeof changes[key].currentValue === 'boolean') changes[key].currentValue ? this.loadSpinner() : this.dismissSpinner();
      }
    }
  }

  loadSpinner() {
    this.spinnerRef = this.viewContainerRef.createComponent(SpinnerLoaderComponent);
    this.spinnerRef.instance.size = this.size ?? '3x';
  }
  
  dismissSpinner() {
    if (this.spinnerRef) {
      this.spinnerRef.destroy();
    }
  }

}
